var map = {
	"./databases/firebase.png": 6823,
	"./databases/mongodb.png": 656,
	"./databases/mysql.png": 6316,
	"./databases/postgresql.png": 8858,
	"./databases/supabase.png": 6150,
	"./dialogflow.png": 7493,
	"./flask.png": 8092,
	"./frameworks/bootstrap.png": 6997,
	"./frameworks/dotnet.png": 1961,
	"./frameworks/express.png": 5243,
	"./frameworks/flutter.png": 4301,
	"./frameworks/next.png": 7092,
	"./frameworks/node.png": 7475,
	"./frameworks/react.png": 5818,
	"./frameworks/tailwind.png": 5655,
	"./languages/c.png": 8854,
	"./languages/cpp.png": 6094,
	"./languages/cs.png": 7791,
	"./languages/dart.png": 7378,
	"./languages/java.png": 1513,
	"./languages/javascript.png": 7284,
	"./languages/python.png": 1283,
	"./languages/typescript.png": 2452,
	"./opencv.png": 3706,
	"./tools/figma.png": 8501,
	"./tools/git.png": 5893,
	"./work/hxil.png": 8456,
	"./work/pmi.png": 4793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5255;